import React, { Component } from 'react';
import { connect } from 'react-redux';

class ArticleItem extends Component {
    render() {
      return (      
        <div className="col-sm-4 col-lg-3 m-b-md" key={this.props.hit.externalUrl}>
            <a href={this.props.hit.externalUrl} className="d-flex lift lift--compact---mini">
                <div className="lift__label--static">
                    <span>{this.props.hit.kickerText}</span>
                </div>
                <div className="lift__image" style={{backgroundImage: `url( ${this.props.hit.imageExternalUrl})`}}>
                </div>
                <div className="lift__text">
                    <div className="lift__text--content">
                        <div className="d-flex justify-content-center">
                            <time>{this.props.hit.date}</time>
                            <p>{this.props.hit.heading}</p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    	);
    }
}

export default ArticleItem;